import { render, staticRenderFns } from "./Productlists.vue?vue&type=template&id=0ef72f18&scoped=true"
import script from "./Productlists.vue?vue&type=script&lang=js"
export * from "./Productlists.vue?vue&type=script&lang=js"
import style0 from "./Productlists.vue?vue&type=style&index=0&id=0ef72f18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef72f18",
  null
  
)

export default component.exports